export type AidCallDebugSnapshot = {
  version: string;
  isAuthenticated: boolean;
  role: string | null;
  effectiveRole: string | null;
  permissionLevel: string | null;
  userOptedOnline: boolean;
  manualDisconnect: boolean;
  sipStatus: string;
  socketStatus: string;
  lastError: string | null;
  extension: string | null;
  sipUsername: string | null;
  socketId: string | null;
  sipTransportState: string | null;
  sipRegistererState: string | null;
  sipWssUrl: string | null;
  sipDomain: string | null;
  sipUri: string | null;
  sipAuthUsername: string | null;
  sipHasPassword: boolean;
  sipLastRegisterRejectStatusCode: number | null;
  sipLastRegisterRejectReason: string | null;
};

declare global {
  interface Window {
    __aidcallDebug?: () => AidCallDebugSnapshot;
  }
}

export const registerAidCallDebug = (getter: () => AidCallDebugSnapshot) => {
  window.__aidcallDebug = getter;
};

export const unregisterAidCallDebug = () => {
  delete window.__aidcallDebug;
};
